<template>
  <div class="flex flex-wrap">
    <Form :pageType="pageType" :onSubmit="onSubmit" :alertType="alertType" :alertMessage="alertMessage"
      :clientProps="currentClient" :showModal="showModal" :toggleModal="toggleModal" />
    <div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="w-full lg:w-2/12 text-blueGray-700 text-xl font-bold">API Request</h6>


            <a class="w-full lg:w-2/12 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              href="/admin/api-requests/new">
              Create New
            </a>
          </div>
          <br />
          <hr />
          <div class="text-center flex justify-between py-6">
            <div class="w-full lg:w-12/12 flex flex-wrap">
              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
                <select v-model="filter.client_name"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getAppNames()">
                  <option v-for="(item, key) in filterClients['client_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">App Name</label>
                <select v-model="filter.app_name"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getVersions()">
                  <option v-for="(item, key) in filterClients['app_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Version</label>
                <select v-model="filter.version"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getIntentions()">
                  <option v-for="(item, key) in filterClients['version']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Intention</label>
                <select v-model="filter.intention"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                  <option v-for="(item, key) in filterClients['intention']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>
              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="search()">
                Search
              </a>
              <a class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="clear()">
                Clear
              </a>
            </div>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <!-- Projects table -->
          <table class="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  ID
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Client Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  App Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Version
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Intention
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in clients" :key="item.id" data-bs-toggle="tooltip"
                :title="JSON.stringify(item.payload, null, 2)">
                <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ item.id }}
                </th>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.client_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.app_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.version }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.intention }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  <router-link :to="'/admin/api-requests/' + item.id + '/edit'"
                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Try
                    !</router-link>
                  <a href="#" v-on:click="deleteItem(item)"
                    class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Delete</a>
                </td>
              </tr>

            </tbody>
          </table>
          <Pagination :totalCounts="totalCounts" :onPageChange="handlePageChange" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiPlaygroundService from "@/services/ApiPlaygroundService";
import FilterDataService from "@/services/FilterDataService";
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/clients/Form.vue";
import Pagination from "@/components/Paginate/Pagination.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue/ConfirmDialogue.vue";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-request", "API Request", "/admin/api-requests")
    return {
      appStore
    }
  },
  components: {
    Form,
    Pagination,
    ConfirmDialogue
  },
  data() {
    return {
      totalCounts: 0,
      clients: [],
      currentClient: {},
      currentIndex: -1,
      showModal: false,
      alertType: '',
      alertMessage: '',
      pageType: 'Add',
      filter: {},
      filterClients: {}
    }
  },
  methods: {
    handlePageChange(page) {
      var payload = this.filter
      payload['limit'] = constants.pageLimit
      payload['page'] = page
      ApiPlaygroundService.search(payload)
        .then(response => {
          this.clients = response.data["data"]["requests"];

        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    onClickAdd() {
      this.currentClient = {};
      this.showModal = !this.showModal;
      this.pageType = 'Add'
    },
    retrieveClients() {
      ApiPlaygroundService.getAll()
        .then(response => {
          this.clients = response.data["data"]["requests"];
          this.totalCounts = response.data["data"]["count"];
          console.log(response.data);
          this.getClientNames()
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getClientNames() {
      this.filter = {}
      this.filterClients['app_name'] = []
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['client_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getAppNames() {
      this.filter = {
        client_name: this.filter.client_name
      }
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['app_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getVersions() {
      this.filter = {
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
      }
      this.filterClients['intention'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['version'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getIntentions() {
      this.filter = {
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
        version: this.filter.version
      }
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['intention'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    search() {
      ApiPlaygroundService.search(this.filter)
        .then(response => {
          this.clients = response.data["data"]["requests"];
          this.totalCounts = response.data["data"]["count"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    clear() {
      this.filter = {}
      this.filterClients = {}
      this.retrieveClients();
    },
    refreshList() {
      this.retrieveClients();
      this.currentClient = {};
      this.toggleModal()
    },

    setActiveClient(item, index) {
      this.currentClient = item;
      console.log(this.currentClient)
      this.currentIndex = item ? index : -1;
      this.showModal = !this.showModal;
      this.pageType = 'Edit'
    },

    async deleteItem(item) {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Attention',
        message: 'Are you sure you want to delete this item?',
        okButton: 'Delete',
      })

      if (ok) {
        ApiPlaygroundService.delete(item.id)
          .then(() => {
            this.alertType = 'Success'
            this.alertMessage = 'Client successfuly deleted'
            this.countDownTimer(3, this.retrieveClients)
          })
          .catch(e => {
            ErrorHandler(e);
          });
      }
    },
    onSubmit(client) {
      if (this.currentClient['id'] != null) {
        this.editClient(client)
      } else if (this.currentClient['id'] == null) {
        this.addClient(client)
      }

    },
    addClient(client) {
      ApiPlaygroundService.create(client)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    },
    editClient(client) {
      ApiPlaygroundService.update(this.currentClient.id, client)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly updated'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    }
  },
  mounted() {
    this.retrieveClients();
  }
};
</script>
